import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'

import Login from '@/components/authentication/Login'
import Home from '@/components/Home'
import Contacts from '@/components/contacts/ContactList'
import Contact from '@/components/contacts/Contact'
import LeadsView from '@/components/leads/LeadsView'
import Admin from '@/components/admin/Admin'
import Scheduler from '@/components/scheduling/Scheduler'

import Projects from '@/components/projects/ProjectList'
import Project from '@/components/projects/Project'

import Users from '@/components/admin/users/Users'
import User from '@/components/admin/users/User'

import TaskTemplates from '@/components/tasks/TaskTemplates'
import VendorList from '@/components/vendors/VendorList'
import Vendor from '@/components/vendors/Vendor'
import BuilderList from '@/components/builders/BuilderList'
import Builder from '@/components/builders/Builder'

import ProjectGrid from '@/components/reports/ProjectGrid'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/home', beforeEnter: AuthGuard },
    // { path: '/', redirect: '/welcome', beforeEnter: AuthGuard },
    { path: '/home', name: 'Home', component: Home, beforeEnter: AuthGuard },
    { path: '/login', name: 'Login', component: Login },
    { path: '/admin', name: 'Admin', component: Admin, beforeEnter: AuthGuard },
    { path: '/customers', name: 'Customers', component: Contacts, beforeEnter: AuthGuard },
    { path: '/customers/:id', name: 'Customer', props: true, component: Contact, beforeEnter: AuthGuard },
    { path: '/leads', name: 'Leads', component: LeadsView, beforeEnter: AuthGuard },
    { path: '/projects/:status', name: 'Projects', props: true, component: Projects, beforeEnter: AuthGuard },
    { path: '/project/:id', name: 'Project', props: true, component: Project, beforeEnter: AuthGuard },
    { path: '/users', name: 'Users', component: Users, beforeEnter: AuthGuard },
    { path: '/users/:id', name: 'User', props: true, component: User, beforeEnter: AuthGuard },
    { path: '/tasks/templates', name: 'Task List Templates', component: TaskTemplates, beforeEnter: AuthGuard },
    { path: '/vendors', name: 'Vendor List', component: VendorList, beforeEnter: AuthGuard },
    { path: '/vendors/:id', name: 'Vendor', props: true, component: Vendor, beforeEnter: AuthGuard },
    { path: '/builders', name: 'Builder List', component: BuilderList, beforeEnter: AuthGuard },
    { path: '/builders/:id', name: 'Builder', props: true, component: Builder, beforeEnter: AuthGuard },
    { path: '/reports/projectsummary/:projectStatus', name: 'Projects Summary', props: true, component: ProjectGrid, beforeEnter: AuthGuard },
    { path: '/scheduler', name: 'Scheduler', props: true, component: Scheduler, beforeEnter: AuthGuard }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js